import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DrawerComponent } from './drawer/drawer.component';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { SharedPipesModule } from '../pipes/shared-pipes.module';

import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { ListLegendComponent } from './list-legend/list-legend.component';
import { LoaderComponent } from './loader/loader.component';
import { Ng2FileDropComponent } from './ng2-file-drop/ng2-file-drop.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import {
	EmissionsBoxInformativeComponent
} from '@app-shared/components/emissions-box-informative/emissions-box-informative.component';
import {Co2LegendComponent} from "@app-shared/components/co2-legend/co2-legend.component";
import { ImageModalComponent } from './image-modal/image-modal.component';
import { EsgReportModalComponent } from './esg-report-modal/esg-report-modal.component';
const components = [BtnLoadingComponent, Ng2FileDropComponent, LoaderComponent,
	StarRatingComponent, ListLegendComponent, EmissionsBoxInformativeComponent, Co2LegendComponent,ImageModalComponent, DrawerComponent, EsgReportModalComponent];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		SharedPipesModule,
		SharedDirectivesModule,
		PerfectScrollbarModule,
		NgbModule,
		FileUploadModule
	],
	declarations: components,
	exports: components
})
export class SharedComponentsModule {}
